<!-- Created by Alex Poh. on 12/04/20.-->
<!-- Copyright © 2020 Curriculum Ltd. All rights reserved.-->

<div *ngIf="isDataPresented" id="gantt-chart" class="gantt-chart m-t-16" #chart>
</div>
<curr-gantt-without-data *ngIf="!isDataPresented"></curr-gantt-without-data>